<template>
  <v-container class="pa-4 pa-sm-8" fluid>
    <v-row class="mt-3 mt-sm-0">
      <h3 class="dark--text text-h5 font-weight-bold ms-2 mb-6">
        Freeze List
      </h3>
    </v-row>
    <v-row align="center" class="mt-n4 mt-md-0">
      <v-col cols="4" sm="6" lg="4">
        <v-text-field placeholder="search" v-model="search" solo dense @keydown.enter="runSearch()">
          <template v-slot:append>
            <v-icon v-if="search.length > 0" color="dark" class="me-n2" @click="clearSearch()">mdi-close</v-icon>
            <v-icon v-if="search.length == 0" color="dark" class="me-n2" @click="runSearch()">mdi-magnify</v-icon>
          </template>
        </v-text-field>
      </v-col>
      <v-col cols="4" sm="6" lg="3">
        <v-select :items="['All', 'ACTIVE', 'IN_ACTIVE']" v-model="freezeStatus" item-value="value" item-text="text" label="All" solo @change="runSearch()" dense></v-select>
      </v-col>
      <v-col cols="5" sm="6" lg="4">
        <ExportFreeze :headers="headers" :search="search" />
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="freezeDays"
      :mobile-breakpoint="0"
      :options.sync="options"
      :loading="loading"
      :server-items-length="totalItems"
      :footer-props="{ 'items-per-page-options': [25, 50, 100, 500] }"
    >
      <template v-slot:[`item.last_modified_date`]="{ item }">
        <span v-if="item.last_modified_date != 'Invalid Date'">
          {{ item.last_modified_date | moment("MMM DD YYYY") }}
        </span>
      </template>
      <template v-slot:[`item.isPaused`]="{ item }">
        {{ item.isPaused ? "Paused" : "" }}
      </template>

      <template v-slot:[`item.fromDate`]="{ item }">
        {{ new Date(parseInt(item.fromDate)) | moment("MMM DD YYYY") }}
      </template>
      <template v-slot:[`item.endDate`]="{ item }">
        <span v-if="item.endDate">
          {{ new Date(parseInt(item.endDate)) | moment("MMM DD YYYY") }}
        </span>
      </template>

      <template v-slot:[`item.isActive`]="{ item }">
        <v-checkbox :disabled="true" color="primary" disabled-color="primary" v-model="item.isActive"></v-checkbox>
      </template>
      <template v-slot:item.updatedBy="{ item }">
        <span v-if="item.updatedBy">{{ item.updatedBy.firstnameEn }} {{ item.updatedBy.lastnameEn }}</span>
      </template>

      <template v-slot:[`item.customer`]="{ item }">
        <router-link
          v-if="item.user"
          :to="{
            name: 'CustomerDetails',
            query: { customerId: item.customer._id },
          }"
          class="mx-auto"
        >
          {{ capitalizeFirstLetter(item.user.firstnameEn) }}
          {{ capitalizeFirstLetter(item.user.lastnameEn) }}
        </router-link>
      </template>
      <template v-slot:item.phone="{ item }">
        <span v-if="item.user">{{ item.user.phone }} </span>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { tz } from "moment-timezone";
import ExportFreeze from "./ExportFreeze.vue";
export default {
  components: { ExportFreeze },

  created() {
    this.getAllFreeze();
  },
  watch: {
    options: {
      handler() {
        this.getAllFreeze();
      },
      deep: true,
    },
  },
  methods: {
    runSearch() {
      this.getAllFreeze();
    },
    clearSearch() {
      this.search = "";
      this.getAllFreeze();
    },
    getAllFreeze() {
      this.loading = true;
      this.$apollo
        .watchQuery({
          query: require("./api/getAllFreeze.graphql"),
          variables: {
            variables: {
              freezeStatus: this.freezeStatus,
              search: "",
              input: { limit: 25, skip: 0 },
            },
          },
        })
        .refetch({
          search: this.search,
          freezeStatus: this.freezeStatus,
          input: {
            limit: this.options.itemsPerPage !== -1 ? this.options.itemsPerPage : 200,
            skip: this.options.page * this.options.itemsPerPage - this.options.itemsPerPage,
          },
        })
        .then(data => {
          debugger;
          this.loading = false;
          if (data.data.getAllFreeze) {
            this.freezeDays = data.data.getAllFreeze.freeze;
            this.totalItems = data.data.getAllFreeze.totalCount;
          }
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
        });
    },
  },

  data() {
    return {
      tz: tz,
      freezeDays: [],
      options: {
        itemsPerPage: 25,
        page: 1,
      },
      freezeStatus: "All",
      search: "",
      totalItems: 25,
      loading: true,
      headers: [
        { text: "Customer", value: "customer", width: 150 },
        { text: "Phone", value: "phone", width: 150 },
        { text: "From Date", value: "fromDate", width: 150 },
        { text: "To Date", value: "endDate" },
        { text: "Active", value: "isActive" },
        { text: "Updated By", value: "updatedBy" },
        { text: "Remarks", value: "remark", sortable: false },
        { text: "Auto Expired", value: "isAutoExpired" },
      ],
    };
  },
};
</script>

<style>
.theme--light.v-list-item--active:hover::before,
.theme--light.v-list-item--active::before {
  opacity: 0.2 !important;
}
</style>
